module.exports = __webpack_public_path__ + "img/shopping-cart.1d629f2a.png";